export const content = {
  showPassword: 'Show password',
  hidePassword: 'Hide password',
}
